var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCwhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.794,
    height: 23.936,
    viewBox: "0 0 23.794 23.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M19.451,16.348c-.239-.12-1.793-.837-2.032-.956a.563.563,0,0,0-.717.12c-.239.239-.717.956-.956,1.2-.12.239-.359.239-.6.12a9.771,9.771,0,0,1-2.391-1.434,13.759,13.759,0,0,1-1.673-2.032.526.526,0,0,1,.12-.6c.12-.12.239-.359.478-.478a.906.906,0,0,0,.239-.478.364.364,0,0,0,0-.478,21.247,21.247,0,0,1-.956-2.152c-.12-.837-.359-.837-.6-.837h-.6a1.363,1.363,0,0,0-.717.359,3.44,3.44,0,0,0-1.076,2.51,6.261,6.261,0,0,0,1.2,3.108,12.744,12.744,0,0,0,5.02,4.423,9.368,9.368,0,0,0,1.673.6,3.414,3.414,0,0,0,1.912.12,3.1,3.1,0,0,0,2.032-1.434,2,2,0,0,0,.12-1.434l-.478-.239M22.439,5.471A11.914,11.914,0,0,0,3.673,19.815L2,25.911l6.335-1.673a11.81,11.81,0,0,0,17.451-10.4,11.642,11.642,0,0,0-3.347-8.367M19.212,22.205a10.031,10.031,0,0,1-5.259,1.554,10.482,10.482,0,0,1-5.02-1.315l-.359-.239-3.705.956.956-3.586-.239-.359A10.036,10.036,0,0,1,8.813,5.471,9.723,9.723,0,0,1,22.32,8.579a9.863,9.863,0,0,1-3.108,13.626",
    transform: "translate(-2 -1.975)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwhatsapp);
export default __webpack_public_path__ + "static/media/cwhatsapp.602a1663180011b4d7f07fc9117be70b.svg";
export { ForwardRef as ReactComponent };